/**
 * Vehicle Fitment Data
 * Makes: curated list of popular brands.
 * Models: fetched dynamically from NHTSA API (see vehicle-selector.js).
 * Years:  generated statically (1990 – current year + 1).
 * Engine: optional, not fetched automatically.
 */
window.VehicleData = (function () {

  var makes = [
    "Acura","Alfa Romeo","Aston Martin","Audi","Bentley",
    "BMW","Buick","Cadillac","Chevrolet","Chrysler",
    "Dodge","Ferrari","Fiat","Ford","Genesis",
    "GMC","Honda","Hyundai","Infiniti","Jaguar",
    "Jeep","Kia","Lamborghini","Land Rover","Lexus",
    "Lincoln","Maserati","Mazda","McLaren","Mercedes-Benz",
    "MINI","Mitsubishi","Nissan","Porsche","Ram",
    "Rolls-Royce","Subaru","Tesla","Toyota","Volkswagen",
    "Volvo"
  ];

  /* ---------- legacy stub kept for backward compat ---------- */
  var data = {
    "Chevrolet": {
      "Silverado 1500": {
        "2024": ["4.3L V6", "5.3L V8", "6.2L V8", "2.7L Turbo 4-Cyl"],
        "2023": ["4.3L V6", "5.3L V8", "6.2L V8", "2.7L Turbo 4-Cyl"],
        "2022": ["4.3L V6", "5.3L V8", "6.2L V8", "2.7L Turbo 4-Cyl"],
        "2021": ["4.3L V6", "5.3L V8", "6.2L V8", "2.7L Turbo 4-Cyl"],
        "2020": ["4.3L V6", "5.3L V8", "6.2L V8"],
        "2019": ["4.3L V6", "5.3L V8", "6.2L V8"],
        "2018": ["4.3L V6", "5.3L V8", "6.2L V8"],
        "2017": ["4.3L V6", "5.3L V8", "6.2L V8"],
        "2016": ["4.3L V6", "5.3L V8", "6.2L V8"],
        "2015": ["4.3L V6", "5.3L V8", "6.2L V8"]
      },
      "Camaro": {
        "2024": ["2.0L Turbo 4-Cyl", "3.6L V6", "6.2L V8"],
        "2023": ["2.0L Turbo 4-Cyl", "3.6L V6", "6.2L V8"],
        "2022": ["2.0L Turbo 4-Cyl", "3.6L V6", "6.2L V8"],
        "2021": ["2.0L Turbo 4-Cyl", "3.6L V6", "6.2L V8"],
        "2020": ["2.0L Turbo 4-Cyl", "3.6L V6", "6.2L V8"],
        "2019": ["2.0L Turbo 4-Cyl", "3.6L V6", "6.2L V8"],
        "2018": ["2.0L Turbo 4-Cyl", "3.6L V6", "6.2L V8"],
        "2016": ["2.0L Turbo 4-Cyl", "3.6L V6", "6.2L V8"]
      },
      "Malibu": {
        "2023": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2022": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2021": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2020": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2019": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2018": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2016": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"]
      },
      "Equinox": {
        "2024": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2023": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2022": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2021": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2020": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2019": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2018": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2017": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2016": ["2.4L 4-Cyl", "3.6L V6"]
      },
      "Tahoe": {
        "2024": ["5.3L V8", "6.2L V8"],
        "2023": ["5.3L V8", "6.2L V8"],
        "2022": ["5.3L V8", "6.2L V8"],
        "2021": ["5.3L V8", "6.2L V8"],
        "2020": ["5.3L V8"],
        "2019": ["5.3L V8"],
        "2018": ["5.3L V8"],
        "2017": ["5.3L V8"],
        "2016": ["5.3L V8"]
      }
    },
    "Ford": {
      "F-150": {
        "2024": ["2.7L EcoBoost V6", "3.5L EcoBoost V6", "5.0L V8", "3.3L V6"],
        "2023": ["2.7L EcoBoost V6", "3.5L EcoBoost V6", "5.0L V8", "3.3L V6"],
        "2022": ["2.7L EcoBoost V6", "3.5L EcoBoost V6", "5.0L V8", "3.3L V6"],
        "2021": ["2.7L EcoBoost V6", "3.5L EcoBoost V6", "5.0L V8", "3.3L V6"],
        "2020": ["2.7L EcoBoost V6", "3.5L EcoBoost V6", "5.0L V8"],
        "2019": ["2.7L EcoBoost V6", "3.5L EcoBoost V6", "5.0L V8"],
        "2018": ["2.7L EcoBoost V6", "3.5L EcoBoost V6", "5.0L V8"],
        "2017": ["2.7L EcoBoost V6", "3.5L EcoBoost V6", "5.0L V8"],
        "2016": ["2.7L EcoBoost V6", "3.5L EcoBoost V6", "5.0L V8"],
        "2015": ["2.7L EcoBoost V6", "3.5L EcoBoost V6", "5.0L V8"]
      },
      "Mustang": {
        "2024": ["2.3L EcoBoost 4-Cyl", "5.0L V8"],
        "2023": ["2.3L EcoBoost 4-Cyl", "5.0L V8"],
        "2022": ["2.3L EcoBoost 4-Cyl", "5.0L V8"],
        "2021": ["2.3L EcoBoost 4-Cyl", "5.0L V8"],
        "2020": ["2.3L EcoBoost 4-Cyl", "5.0L V8"],
        "2019": ["2.3L EcoBoost 4-Cyl", "5.0L V8"],
        "2018": ["2.3L EcoBoost 4-Cyl", "5.0L V8"],
        "2017": ["2.3L EcoBoost 4-Cyl", "5.0L V8"],
        "2016": ["2.3L EcoBoost 4-Cyl", "5.0L V8", "3.7L V6"],
        "2015": ["2.3L EcoBoost 4-Cyl", "5.0L V8", "3.7L V6"]
      },
      "Explorer": {
        "2024": ["2.3L EcoBoost 4-Cyl", "3.0L EcoBoost V6"],
        "2023": ["2.3L EcoBoost 4-Cyl", "3.0L EcoBoost V6"],
        "2022": ["2.3L EcoBoost 4-Cyl", "3.0L EcoBoost V6"],
        "2021": ["2.3L EcoBoost 4-Cyl", "3.0L EcoBoost V6"],
        "2020": ["2.3L EcoBoost 4-Cyl", "3.0L EcoBoost V6"],
        "2019": ["2.3L EcoBoost 4-Cyl"],
        "2018": ["2.3L EcoBoost 4-Cyl", "3.5L V6"],
        "2017": ["2.3L EcoBoost 4-Cyl", "3.5L V6"],
        "2016": ["2.3L EcoBoost 4-Cyl", "3.5L V6"],
        "2015": ["2.3L EcoBoost 4-Cyl", "3.5L V6"]
      },
      "Escape": {
        "2024": ["1.5L EcoBoost 3-Cyl", "2.0L EcoBoost 4-Cyl"],
        "2023": ["1.5L EcoBoost 3-Cyl", "2.0L EcoBoost 4-Cyl"],
        "2022": ["1.5L EcoBoost 3-Cyl", "2.0L EcoBoost 4-Cyl"],
        "2021": ["1.5L EcoBoost 3-Cyl", "2.0L EcoBoost 4-Cyl"],
        "2020": ["1.5L EcoBoost 3-Cyl", "2.0L EcoBoost 4-Cyl"],
        "2019": ["1.5L EcoBoost 4-Cyl", "2.0L EcoBoost 4-Cyl"],
        "2018": ["1.5L EcoBoost 4-Cyl", "2.0L EcoBoost 4-Cyl"],
        "2017": ["1.5L EcoBoost 4-Cyl", "2.0L EcoBoost 4-Cyl", "2.5L 4-Cyl"],
        "2016": ["1.6L EcoBoost 4-Cyl", "2.0L EcoBoost 4-Cyl", "2.5L 4-Cyl"],
        "2015": ["1.6L EcoBoost 4-Cyl", "2.0L EcoBoost 4-Cyl", "2.5L 4-Cyl"]
      }
    },
    "Toyota": {
      "Camry": {
        "2024": ["2.5L 4-Cyl", "3.5L V6", "2.5L Hybrid 4-Cyl"],
        "2023": ["2.5L 4-Cyl", "3.5L V6", "2.5L Hybrid 4-Cyl"],
        "2022": ["2.5L 4-Cyl", "3.5L V6", "2.5L Hybrid 4-Cyl"],
        "2021": ["2.5L 4-Cyl", "3.5L V6", "2.5L Hybrid 4-Cyl"],
        "2020": ["2.5L 4-Cyl", "3.5L V6", "2.5L Hybrid 4-Cyl"],
        "2019": ["2.5L 4-Cyl", "3.5L V6", "2.5L Hybrid 4-Cyl"],
        "2018": ["2.5L 4-Cyl", "3.5L V6", "2.5L Hybrid 4-Cyl"],
        "2017": ["2.5L 4-Cyl", "3.5L V6", "2.5L Hybrid 4-Cyl"],
        "2016": ["2.5L 4-Cyl", "3.5L V6", "2.5L Hybrid 4-Cyl"],
        "2015": ["2.5L 4-Cyl", "3.5L V6", "2.5L Hybrid 4-Cyl"]
      },
      "Corolla": {
        "2024": ["2.0L 4-Cyl", "1.8L Hybrid 4-Cyl"],
        "2023": ["2.0L 4-Cyl", "1.8L Hybrid 4-Cyl"],
        "2022": ["2.0L 4-Cyl", "1.8L Hybrid 4-Cyl"],
        "2021": ["2.0L 4-Cyl", "1.8L Hybrid 4-Cyl"],
        "2020": ["2.0L 4-Cyl", "1.8L Hybrid 4-Cyl"],
        "2019": ["1.8L 4-Cyl"],
        "2018": ["1.8L 4-Cyl"],
        "2017": ["1.8L 4-Cyl"],
        "2016": ["1.8L 4-Cyl"],
        "2015": ["1.8L 4-Cyl"]
      },
      "RAV4": {
        "2024": ["2.5L 4-Cyl", "2.5L Hybrid 4-Cyl"],
        "2023": ["2.5L 4-Cyl", "2.5L Hybrid 4-Cyl"],
        "2022": ["2.5L 4-Cyl", "2.5L Hybrid 4-Cyl"],
        "2021": ["2.5L 4-Cyl", "2.5L Hybrid 4-Cyl"],
        "2020": ["2.5L 4-Cyl", "2.5L Hybrid 4-Cyl"],
        "2019": ["2.5L 4-Cyl"],
        "2018": ["2.5L 4-Cyl"],
        "2017": ["2.5L 4-Cyl"],
        "2016": ["2.5L 4-Cyl"],
        "2015": ["2.5L 4-Cyl"]
      },
      "Tacoma": {
        "2024": ["2.4L Turbo 4-Cyl", "2.4L Hybrid 4-Cyl"],
        "2023": ["2.7L 4-Cyl", "3.5L V6"],
        "2022": ["2.7L 4-Cyl", "3.5L V6"],
        "2021": ["2.7L 4-Cyl", "3.5L V6"],
        "2020": ["2.7L 4-Cyl", "3.5L V6"],
        "2019": ["2.7L 4-Cyl", "3.5L V6"],
        "2018": ["2.7L 4-Cyl", "3.5L V6"],
        "2017": ["2.7L 4-Cyl", "3.5L V6"],
        "2016": ["2.7L 4-Cyl", "3.5L V6"],
        "2015": ["2.7L 4-Cyl", "4.0L V6"]
      }
    },
    "Honda": {
      "Civic": {
        "2024": ["1.5L Turbo 4-Cyl", "2.0L 4-Cyl"],
        "2023": ["1.5L Turbo 4-Cyl", "2.0L 4-Cyl"],
        "2022": ["1.5L Turbo 4-Cyl", "2.0L 4-Cyl"],
        "2021": ["1.5L Turbo 4-Cyl", "2.0L 4-Cyl"],
        "2020": ["1.5L Turbo 4-Cyl", "2.0L 4-Cyl"],
        "2019": ["1.5L Turbo 4-Cyl", "2.0L 4-Cyl"],
        "2018": ["1.5L Turbo 4-Cyl", "2.0L 4-Cyl"],
        "2017": ["1.5L Turbo 4-Cyl", "2.0L 4-Cyl"],
        "2016": ["1.5L Turbo 4-Cyl", "2.0L 4-Cyl"],
        "2015": ["1.8L 4-Cyl", "2.4L 4-Cyl"]
      },
      "Accord": {
        "2024": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl", "2.0L Hybrid 4-Cyl"],
        "2023": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl", "2.0L Hybrid 4-Cyl"],
        "2022": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2021": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2020": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2019": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2018": ["1.5L Turbo 4-Cyl", "2.0L Turbo 4-Cyl"],
        "2017": ["2.4L 4-Cyl", "3.5L V6"],
        "2016": ["2.4L 4-Cyl", "3.5L V6"],
        "2015": ["2.4L 4-Cyl", "3.5L V6"]
      },
      "CR-V": {
        "2024": ["1.5L Turbo 4-Cyl", "2.0L Hybrid 4-Cyl"],
        "2023": ["1.5L Turbo 4-Cyl", "2.0L Hybrid 4-Cyl"],
        "2022": ["1.5L Turbo 4-Cyl", "2.0L Hybrid 4-Cyl"],
        "2021": ["1.5L Turbo 4-Cyl", "2.0L Hybrid 4-Cyl"],
        "2020": ["1.5L Turbo 4-Cyl"],
        "2019": ["1.5L Turbo 4-Cyl"],
        "2018": ["1.5L Turbo 4-Cyl"],
        "2017": ["1.5L Turbo 4-Cyl"],
        "2016": ["2.4L 4-Cyl"],
        "2015": ["2.4L 4-Cyl"]
      },
      "Pilot": {
        "2024": ["3.5L V6"],
        "2023": ["3.5L V6"],
        "2022": ["3.5L V6"],
        "2021": ["3.5L V6"],
        "2020": ["3.5L V6"],
        "2019": ["3.5L V6"],
        "2018": ["3.5L V6"],
        "2017": ["3.5L V6"],
        "2016": ["3.5L V6"],
        "2015": ["3.5L V6"]
      }
    },
    "BMW": {
      "3 Series": {
        "2024": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2023": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2022": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2021": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2020": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2019": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2018": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2017": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2016": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2015": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"]
      },
      "5 Series": {
        "2024": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2023": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2022": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2021": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2020": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2019": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2018": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2017": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"],
        "2016": ["2.0L Turbo 4-Cyl", "3.0L Turbo 6-Cyl"]
      },
      "X5": {
        "2024": ["3.0L Turbo 6-Cyl", "4.4L Turbo V8"],
        "2023": ["3.0L Turbo 6-Cyl", "4.4L Turbo V8"],
        "2022": ["3.0L Turbo 6-Cyl", "4.4L Turbo V8"],
        "2021": ["3.0L Turbo 6-Cyl", "4.4L Turbo V8"],
        "2020": ["3.0L Turbo 6-Cyl", "4.4L Turbo V8"],
        "2019": ["3.0L Turbo 6-Cyl", "4.4L Turbo V8"],
        "2018": ["3.0L Turbo 6-Cyl", "4.4L Turbo V8"],
        "2017": ["3.0L Turbo 6-Cyl", "4.4L Turbo V8"],
        "2016": ["3.0L Turbo 6-Cyl", "4.4L Turbo V8"],
        "2015": ["3.0L Turbo 6-Cyl", "4.4L Turbo V8"]
      }
    },
    "Dodge": {
      "Charger": {
        "2023": ["3.6L V6", "5.7L HEMI V8", "6.2L HEMI V8", "6.4L HEMI V8"],
        "2022": ["3.6L V6", "5.7L HEMI V8", "6.2L HEMI V8", "6.4L HEMI V8"],
        "2021": ["3.6L V6", "5.7L HEMI V8", "6.2L HEMI V8", "6.4L HEMI V8"],
        "2020": ["3.6L V6", "5.7L HEMI V8", "6.2L HEMI V8", "6.4L HEMI V8"],
        "2019": ["3.6L V6", "5.7L HEMI V8", "6.2L HEMI V8", "6.4L HEMI V8"],
        "2018": ["3.6L V6", "5.7L HEMI V8", "6.2L HEMI V8", "6.4L HEMI V8"],
        "2017": ["3.6L V6", "5.7L HEMI V8", "6.4L HEMI V8"],
        "2016": ["3.6L V6", "5.7L HEMI V8", "6.4L HEMI V8"],
        "2015": ["3.6L V6", "5.7L HEMI V8", "6.4L HEMI V8"]
      },
      "Challenger": {
        "2023": ["3.6L V6", "5.7L HEMI V8", "6.2L HEMI V8", "6.4L HEMI V8"],
        "2022": ["3.6L V6", "5.7L HEMI V8", "6.2L HEMI V8", "6.4L HEMI V8"],
        "2021": ["3.6L V6", "5.7L HEMI V8", "6.2L HEMI V8", "6.4L HEMI V8"],
        "2020": ["3.6L V6", "5.7L HEMI V8", "6.2L HEMI V8", "6.4L HEMI V8"],
        "2019": ["3.6L V6", "5.7L HEMI V8", "6.2L HEMI V8", "6.4L HEMI V8"],
        "2018": ["3.6L V6", "5.7L HEMI V8", "6.4L HEMI V8"],
        "2017": ["3.6L V6", "5.7L HEMI V8", "6.4L HEMI V8"],
        "2016": ["3.6L V6", "5.7L HEMI V8", "6.4L HEMI V8"],
        "2015": ["3.6L V6", "5.7L HEMI V8", "6.4L HEMI V8"]
      },
      "Ram 1500": {
        "2024": ["3.6L V6", "5.7L HEMI V8", "3.0L EcoDiesel V6"],
        "2023": ["3.6L V6", "5.7L HEMI V8", "3.0L EcoDiesel V6"],
        "2022": ["3.6L V6", "5.7L HEMI V8", "3.0L EcoDiesel V6"],
        "2021": ["3.6L V6", "5.7L HEMI V8", "3.0L EcoDiesel V6"],
        "2020": ["3.6L V6", "5.7L HEMI V8", "3.0L EcoDiesel V6"],
        "2019": ["3.6L V6", "5.7L HEMI V8", "3.0L EcoDiesel V6"],
        "2018": ["3.6L V6", "5.7L HEMI V8", "3.0L EcoDiesel V6"],
        "2017": ["3.6L V6", "5.7L HEMI V8"],
        "2016": ["3.6L V6", "5.7L HEMI V8"],
        "2015": ["3.6L V6", "5.7L HEMI V8"]
      }
    },
    "Jeep": {
      "Wrangler": {
        "2024": ["2.0L Turbo 4-Cyl", "3.6L V6", "3.0L EcoDiesel V6"],
        "2023": ["2.0L Turbo 4-Cyl", "3.6L V6", "3.0L EcoDiesel V6"],
        "2022": ["2.0L Turbo 4-Cyl", "3.6L V6", "3.0L EcoDiesel V6"],
        "2021": ["2.0L Turbo 4-Cyl", "3.6L V6", "3.0L EcoDiesel V6"],
        "2020": ["2.0L Turbo 4-Cyl", "3.6L V6", "3.0L EcoDiesel V6"],
        "2019": ["2.0L Turbo 4-Cyl", "3.6L V6"],
        "2018": ["3.6L V6"],
        "2017": ["3.6L V6"],
        "2016": ["3.6L V6"],
        "2015": ["3.6L V6"]
      },
      "Grand Cherokee": {
        "2024": ["3.6L V6", "5.7L HEMI V8", "3.0L EcoDiesel V6"],
        "2023": ["3.6L V6", "5.7L HEMI V8", "3.0L EcoDiesel V6"],
        "2022": ["3.6L V6", "5.7L HEMI V8", "3.0L EcoDiesel V6"],
        "2021": ["3.6L V6", "5.7L HEMI V8"],
        "2020": ["3.6L V6", "5.7L HEMI V8", "3.0L EcoDiesel V6"],
        "2019": ["3.6L V6", "5.7L HEMI V8", "3.0L EcoDiesel V6"],
        "2018": ["3.6L V6", "5.7L HEMI V8", "3.0L EcoDiesel V6"],
        "2017": ["3.6L V6", "5.7L HEMI V8"],
        "2016": ["3.6L V6", "5.7L HEMI V8"],
        "2015": ["3.6L V6", "5.7L HEMI V8"]
      }
    },
    "GMC": {
      "Sierra 1500": {
        "2024": ["2.7L Turbo 4-Cyl", "4.3L V6", "5.3L V8", "6.2L V8"],
        "2023": ["2.7L Turbo 4-Cyl", "4.3L V6", "5.3L V8", "6.2L V8"],
        "2022": ["2.7L Turbo 4-Cyl", "4.3L V6", "5.3L V8", "6.2L V8"],
        "2021": ["2.7L Turbo 4-Cyl", "4.3L V6", "5.3L V8", "6.2L V8"],
        "2020": ["4.3L V6", "5.3L V8", "6.2L V8"],
        "2019": ["4.3L V6", "5.3L V8", "6.2L V8"],
        "2018": ["4.3L V6", "5.3L V8", "6.2L V8"],
        "2017": ["4.3L V6", "5.3L V8", "6.2L V8"],
        "2016": ["4.3L V6", "5.3L V8", "6.2L V8"],
        "2015": ["4.3L V6", "5.3L V8", "6.2L V8"]
      },
      "Yukon": {
        "2024": ["5.3L V8", "6.2L V8"],
        "2023": ["5.3L V8", "6.2L V8"],
        "2022": ["5.3L V8", "6.2L V8"],
        "2021": ["5.3L V8", "6.2L V8"],
        "2020": ["5.3L V8"],
        "2019": ["5.3L V8"],
        "2018": ["5.3L V8"],
        "2017": ["5.3L V8"],
        "2016": ["5.3L V8"],
        "2015": ["5.3L V8"]
      }
    },
    "Nissan": {
      "Altima": {
        "2024": ["2.5L 4-Cyl", "2.0L VC-Turbo 4-Cyl"],
        "2023": ["2.5L 4-Cyl", "2.0L VC-Turbo 4-Cyl"],
        "2022": ["2.5L 4-Cyl", "2.0L VC-Turbo 4-Cyl"],
        "2021": ["2.5L 4-Cyl", "2.0L VC-Turbo 4-Cyl"],
        "2020": ["2.5L 4-Cyl", "2.0L VC-Turbo 4-Cyl"],
        "2019": ["2.5L 4-Cyl", "2.0L VC-Turbo 4-Cyl"],
        "2018": ["2.5L 4-Cyl", "3.5L V6"],
        "2017": ["2.5L 4-Cyl", "3.5L V6"],
        "2016": ["2.5L 4-Cyl", "3.5L V6"],
        "2015": ["2.5L 4-Cyl", "3.5L V6"]
      },
      "Rogue": {
        "2024": ["1.5L Turbo 3-Cyl"],
        "2023": ["1.5L Turbo 3-Cyl"],
        "2022": ["1.5L Turbo 3-Cyl"],
        "2021": ["2.5L 4-Cyl"],
        "2020": ["2.5L 4-Cyl"],
        "2019": ["2.5L 4-Cyl"],
        "2018": ["2.5L 4-Cyl"],
        "2017": ["2.5L 4-Cyl"],
        "2016": ["2.5L 4-Cyl"],
        "2015": ["2.5L 4-Cyl"]
      },
      "Frontier": {
        "2024": ["3.8L V6"],
        "2023": ["3.8L V6"],
        "2022": ["3.8L V6"],
        "2021": ["3.8L V6"],
        "2020": ["2.5L 4-Cyl", "4.0L V6"],
        "2019": ["2.5L 4-Cyl", "4.0L V6"],
        "2018": ["2.5L 4-Cyl", "4.0L V6"],
        "2017": ["2.5L 4-Cyl", "4.0L V6"],
        "2016": ["2.5L 4-Cyl", "4.0L V6"],
        "2015": ["2.5L 4-Cyl", "4.0L V6"]
      }
    }
  };

  /* ---------- whitelist from the "Vehicle Selector Settings" section ---------- */
  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }
  function rawLines(s) {
    var seen = {};
    return String(s || '').split(/\r?\n/)
      .map(function (x) { return x.trim(); })
      .filter(function (x) { var k = norm(x); if (!k || seen[k]) return false; seen[k] = true; return true; });
  }
  function lines(s) { return rawLines(s).map(norm); }

  var rules = (function () {
    var cfg = window.VehicleRulesConfig;
    if (!cfg || !cfg.enabled || !cfg.makes || !cfg.makes.length) return null;
    return cfg.makes.map(function (m) {
      return {
        make:     String(m.make).trim(),
        yearFrom: parseInt(m.yearFrom, 10) || 0,
        yearTo:   parseInt(m.yearTo, 10) || 0,
        models:   lines(m.models),
        trims:    lines(m.trims),
        engines:  lines(m.engines),
        modelsRaw:  rawLines(m.models),
        enginesRaw: rawLines(m.engines)
      };
    });
  })();

  function yearAllowed(rule, year) {
    var y = parseInt(year, 10);
    if (!y) return true;
    return (!rule.yearFrom || y >= rule.yearFrom) && (!rule.yearTo || y <= rule.yearTo);
  }

  /** Blocks for `make` covering `year`; a make can have several blocks (e.g. one per model). */
  function rulesFor(make, year) {
    var key = norm(make);
    return rules.filter(function (r) { return norm(r.make) === key && yearAllowed(r, year); });
  }

  /** Of those, the blocks that apply to `model` (a block without models applies to all). */
  function rulesForModel(make, year, model) {
    var key = norm(model);
    return rulesFor(make, year).filter(function (r) { return !r.models.length || r.models.indexOf(key) !== -1; });
  }

  function uniq(list) {
    var seen = {};
    return list.filter(function (x) { var k = norm(x); if (!k || seen[k]) return false; seen[k] = true; return true; });
  }

  /** Union of a raw field over blocks, or null when any block leaves it empty (= use the API). */
  function configured(rs, field) {
    if (rs.some(function (r) { return !r[field].length; })) return null;
    return uniq([].concat.apply([], rs.map(function (r) { return r[field]; })));
  }

  /** API list plus configured values; configured values alone when every block sets them. */
  function merge(rs, field, list) {
    if (!rs.length) return [];
    var own = uniq([].concat.apply([], rs.map(function (r) { return r[field]; })));
    return configured(rs, field) ? own : uniq(list.concat(own));
  }

  return {
    /** True when the store restricts which vehicles can be selected. */
    isRestricted: function () { return !!rules; },

    /** Makes for the dropdown; restricted to configured makes valid for `year` when rules are on. */
    getMakes: function (year) {
      if (!rules) return makes;
      var seen = {};
      return rules
        .filter(function (r) { return yearAllowed(r, year); })
        .map(function (r) { return r.make; })
        .filter(function (m) { var k = norm(m); if (seen[k]) return false; seen[k] = true; return true; })
        .sort(function (a, b) { return a.localeCompare(b); });
    },

    /** Years for the dropdown; drops years no configured make covers. */
    filterYears: function (years) {
      if (!rules) return years;
      return years.filter(function (y) {
        return rules.some(function (r) { return yearAllowed(r, y); });
      });
    },

    /*
     * Configured models/engines are shown exactly as entered, even when the US APIs don't
     * know them (e.g. European names like "3 (F30 F80)" that match the product tags).
     * Engines follow the selected model: only blocks listing that model contribute.
     */

    /** Configured models for make+year, or null when the APIs should be queried. */
    configuredModels: function (make, year) {
      if (!rules) return null;
      var rs = rulesFor(make, year);
      return rs.length ? configured(rs, 'modelsRaw') : [];
    },
    /** Configured engines for make+year+model, or null when the APIs should be queried. */
    configuredEngines: function (make, year, model) {
      if (!rules) return null;
      var rs = rulesForModel(make, year, model);
      return rs.length ? configured(rs, 'enginesRaw') : [];
    },

    filterModels: function (make, list, year) {
      return rules ? merge(rulesFor(make, year), 'modelsRaw', list) : list;
    },
    filterTrims: function (make, list, year, model) {
      if (!rules) return list;
      var rs = rulesForModel(make, year, model);
      if (!rs.length) return [];
      var allowed = configured(rs, 'trims');
      return allowed ? list.filter(function (x) { return allowed.indexOf(norm(x)) !== -1; }) : list;
    },
    filterEngines: function (make, list, year, model) {
      return rules ? merge(rulesForModel(make, year, model), 'enginesRaw', list) : list;
    },

    /**
     * Whether a decoded/saved vehicle is allowed. Returns the configured make spelling
     * (e.g. "AUDI" → "Audi") or null when the vehicle is not allowed.
     */
    matchVehicle: function (v) {
      if (!rules) return v.make;
      var rs = rulesForModel(v.make, v.year, v.model);
      return rs.length ? rs[0].make : null;
    },
    /** Stub – kept for backward compat. Actual models come from NHTSA. */
    getModels: function (make) {
      if (!data[make]) return [];
      return Object.keys(data[make]).sort();
    },
    /** Stub – kept for backward compat. Years are now generated statically. */
    getYears: function (make, model) {
      if (!data[make] || !data[make][model]) return [];
      return Object.keys(data[make][model]).sort(function (a, b) { return b - a; });
    },
    /** Stub – kept for backward compat. Engines are optional/not fetched. */
    getEngines: function (make, model, year) {
      if (!data[make] || !data[make][model] || !data[make][model][year]) return [];
      return data[make][model][year];
    }
  };

})();
